import SphCallout from './Callout.vue';

export { SphCallout };
export default SphCallout;
